module.exports = __webpack_public_path__ + "static/media/Page_51.437fd06b.jpg";